module.exports = __webpack_public_path__ + "assets/images/userPlaceholder.cc884df9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/userPlaceholder.svg
// module id = 73
// module chunks = 1612